
import { tip } from './utils';
import ParamsSign from '@legos/js-security-v3/dist';
import sha256 from 'crypto-js/sha256';
import qs from 'qs';
import sgmReport from './sgmUtil';

const PSign = new ParamsSign({
    appId: "22752",//验签ID，请参考接入步骤2申请验签ID
    debug: false, //测试时开启调试，切记：上线后设置为false。
    preRequest: false,
    onSign: ({ code }) => {},
    onRequestTokenRemotely: ({ code, message }) => {},
    onRequestToken: ({ code, message }) => {}
});
/**
 * 带加签的请求
 * @param function_id
 * @param data
 * @param rej
 * @returns {Promise<unknown> | Promise.Promise}
 */
export const signPost = (function_id, data, rej = null) => {
    return requestSign(function_id, data, 'get', rej);
}

const getToken = (data = {}, cb = null)=> {
    try {
        if (Object.keys(data).length) {
            window?.getJsToken(function (res) {
                let token =  {};
                if (res?.jsToken) token = {'x-api-eid-token': res?.jsToken || ""}
                if (res?.eid) token = {'eid': res?.eid || ""}
                console.log(`获取到设备指指纹`, token);
                cb && cb({
                    data,
                    token
                })
            });
        }  else {
            throw "not object";
        }

    } catch (e) {
        cb && cb(data)
    }

}
const requestSign = (function_id, data, method, rej) => {
    return new Promise((resolve, reject) => {
        getToken(data,(result)=>{
            const body = JSON.stringify(result?.data) || '';
            const token = result?.token ?? {};
            const agent = navigator?.userAgent|| "";
            const uuid = (data && data.uuid) ? data.uuid : '';
            const host = [
							'h5-movie.jd.com',
	            'jd-movie-h5-pro.pf.jd.com',
	            'm-movie.jd.com',
            ].includes(location.host)
                ? 'https://api.m.jd.com/api'
                : 'https://beta-api.m.jd.com/api';
            let params = {
                appid: 'movie',
                functionId: function_id,
                body: body,
                ...token,
                agent
            }
            if (uuid) params.uuid = uuid;
            const paramsSign = {
                functionId: params.functionId,
                appid: params.appid,
                body: sha256(params.body).toString() // color网关body参数需要业务方进行sha256加密
            };
            console.log('参与加签名', paramsSign);
            PSign.sign(paramsSign).then(signedParams => {
                console.log('signedParams', signedParams);
                params.h5st = encodeURI(signedParams.h5st); //关注h5st的编码问题。
                const urlQuery = qs.stringify({
                    ...params,
                });
                console.log('发给后端服务', urlQuery);
                fetch(`${host}?${urlQuery}`, {
                    method,
                    body: method === 'post' ? body : null,
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
                    },
                    cache: 'no-cache',
                    credentials: 'include'
                }).then(res => res.json()).then(res => {
                    if (!res.success) {
                        if (rej) {
                            reject(res);
                        } else {
                            tip('系统繁忙 , 请稍后重试');
                        };

                        return;
                    };
                    resolve(res);
                }, err => {
                    if (rej) {
                        reject(err);
                    } else {
                        tip('系统繁忙,请稍后重试');
                    };
                    sgmReport('-1', err, 3)
                }).catch(() => {
                    tip('系统繁忙,请稍后重试!');
                    sgmReport('-1', {message: '系统繁忙,请稍后重试!'}, 3)
                });
            })
        })
    });
};
export const get = (function_id, data, rej) => {
    return request(function_id, data, 'get', rej);
};
export const post = (function_id, data, rej) => {
    return request(function_id, data, 'post', rej);
};
export const fy_post = (function_id, data, rej) => {
    return fy_request(function_id, data, 'post', rej);
};

// 目前缺少统一Loading动画, 后期添加
const request = (function_id, data, method, rej) => {
    const body = JSON.stringify(data) || '';

    /* 测试环境 */

    // function_id = function_id + '_Test';

    return new Promise((resolve, reject) => {
        const agent = navigator.userAgent;

        const uuid = (data && data.uuid) ? data.uuid : '';

        const host = [
					'h5-movie.jd.com',
	        'm-movie.jd.com',
	        'jd-movie-h5-pro.pf.jd.com'
        ].includes(location.host)
	        ? 'https://api.m.jd.com/api?appid=movie'
	        : 'https://beta-api.m.jd.com/api?appid=movie';
        let url = `${host}&functionId=${function_id}&body=${encodeURIComponent(body)}${uuid ? `&uuid=${uuid}` : ''}`;
        // url += `&client=${client}&osVersion=${osVersion}&clientVersion=${clientVersion}`
        url += `&agent=${agent}`;
        fetch(url, {
            method,
            body: method === 'post' ? body : null,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
            },
            cache: 'no-cache',
            credentials: 'include' // 如果head cros是* 不可以
        }).then(res => res.json()).then(res => {
	          console.log(`接口: ${function_id} 响应:`, res);
            if (!res.success) {
                if (rej) {
                    reject(res);
                } else {
                    tip('系统繁忙 , 请稍后重试');
                };

                return;
            };
            resolve(res);
        }, err => {
            if (rej) {
                reject(err);
            } else {
                tip('系统繁忙,请稍后重试');
            };
            sgmReport('-1', err, 3)
        }).catch(() => {
            tip('系统繁忙,请稍后重试!');
            sgmReport('-1', {message: '系统繁忙,请稍后重试!'}, 3)
        });
    });
};
// 辅营和业务的接口返回数据格式不统一。。。。
const fy_request = (function_id, data, method, rej) => {
    const body = JSON.stringify(data) || '';

    return new Promise((resolve, reject) => {
        const uuid = (data && data.uuid) ? data.uuid : '';

        const host = 'https://api.m.jd.com/api?appid=movie';
        // let host = 'http://beta-api.m.jd.com/api?appid=movie';

        fetch(`${host}&functionId=${function_id}&body=${encodeURIComponent(body)}${uuid ? `&uuid=${uuid}` : ''}`, {
            method,
            body: method === 'post' ? body : null,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            cache: 'no-cache',
            credentials: 'include'
        }).then(res => res.json()).then(res => {
            if (+res.head.code === 200) {
                resolve(res);
            } else if (+res.head.code === 20404) {
                tip('系统繁忙,请稍后重试');
            }
        }, err => {
            if (rej) {
                reject(err);
            } else {
                tip('系统繁忙,请稍后重试');
            };
            sgmReport('-1', err, 3)
        }).catch(() => {
            tip('系统繁忙,请稍后重试!');
            sgmReport('-1', {message: '系统繁忙,请稍后重试!'}, 3)
        });
    });
};